import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import "./index.css";
import HomePage from "./pages/HomePage.jsx";
import ListOfBlogPage from "./pages/ListOfBlog/ListOfBlogPage.jsx";
import GPTpage from "./pages/GPT/GPTpage.jsx";
import CreditCardOptionPage from "./pages/CreditCardOptionPage.jsx";
import CalculatorPage from "./pages/CalculatorPage.jsx";
import SipCalculator from "./pages/SipCalculatorPage.jsx";
import BlogPage from "./pages/Blog/BlogPage.jsx";
import IndivdualCreditCard from "./pages/IndivdualCreditCard.jsx";
import CreditCardComparison from "./pages/CreditCardComparison.jsx";
import CreditCardCategory from "./pages/CreditCardCategory.jsx";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="" element={<HomePage />} />
      <Route path=":lang" element={<HomePage />} />
      <Route path=":lang/tools" element={<CalculatorPage />} />
      <Route path=":lang/credit-cards" element={<CreditCardOptionPage />} />
      <Route
        path=":lang/credit-cards-category/:category"
        element={<CreditCardCategory />}
      />
      <Route path=":lang/credit-card/:id" element={<IndivdualCreditCard />} />
      <Route path=":lang/fintragpt" element={<GPTpage />} />
      <Route path="blog" element={<ListOfBlogPage />} />
      <Route path="blog/:id" element={<BlogPage />} />
      <Route path=":lang/:id" element={<ListOfBlogPage />} />
      <Route path=":lang/calculator/:id" element={<SipCalculator />} />
      <Route
        path=":lang/credit-cards-compare/:cardIds"
        element={<CreditCardComparison />}
        errorBoundary={<CreditCardComparison />}
      />
    </Route>
  )
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
